import { MouseEvent, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { SPA_BASE } from '../../config'

/**
 * Tabla del kit, con desplazamiento horizontal en pantallas angostas. Adentro va un
 * <thead>/<tbody> común: el kit estiliza las etiquetas nativas.
 *
 * `apilable`: bajo 900px cada fila se ve como tarjeta, sin desplazamiento lateral. Cada
 * <td> lleva `data-etiqueta` (el nombre de su columna), que el CSS muestra delante del
 * valor; la celda principal lleva `className="tabla__principal"` y va como título.
 * Es un solo marcado para celular y escritorio (styles/app.css, `.tabla-apilable`).
 */
export function Tabla({ etiqueta, apilable = false, children }: { etiqueta: string; apilable?: boolean; children: ReactNode }) {
  return (
    <div className={`dcc-table-scroll${apilable ? ' tabla-apilable' : ''}`}>
      <table className="dcc-table" aria-label={etiqueta}>
        {children}
      </table>
    </div>
  )
}

/**
 * Filas que llevan a una ficha: devuelve las props del <tr> (`fila(a)`). Toda la fila es
 * cliqueable; el enlace de la celda principal sigue ahí para el teclado y los lectores de
 * pantalla. No navega si el clic fue en algo que ya hace otra cosa (un enlace, un botón,
 * una casilla o un menú) ni si se seleccionó texto. Con Ctrl o ⌘ abre otra pestaña.
 */
// Lo que en una fila ya hace otra cosa: enlaces, botones, casillas, menús, y las celdas
// de la casilla y de las acciones (un clic que no le achunta al control no debe navegar).
const NO_NAVEGA = 'a, button, input, label, [role="menu"], .tabla__casilla, .tabla__acciones'

export function useFilaEnlace() {
  const navigate = useNavigate()
  return (a: string) => ({
    className: 'fila--enlace',
    onClick: (e: MouseEvent<HTMLTableRowElement>) => {
      if ((e.target as HTMLElement).closest(NO_NAVEGA) || window.getSelection()?.toString()) return
      if (e.metaKey || e.ctrlKey) window.open(`${SPA_BASE.replace(/\/$/, '')}${a}`, '_blank')
      else navigate(a)
    },
  })
}
